module.exports = __webpack_public_path__ + "static/media/shield-white.64e59101.svg";